import React, { useEffect, useState } from "react";
import "./message.css";
import CancelIcon from "@mui/icons-material/Cancel";
import instance from "../../ApiInstance/Inetrceptor";
import {
  Drawer,
  Grid,
  Checkbox,
  Button,
  InputLabel,
  TextField,
  Typography,
  Alert,
  Autocomplete,
  InputAdornment,
} from "@mui/material";

import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const MessageTypesDrawer = ({
  getMessageType,
  setIsDrawerOpen,
  isDrawerOpen,
  drawerCaller,
  setBackDrop,
  getMappingStream,
  mappingstream,
  setMappingStream,
   dropdownvisble,
    setDropdownvisble
}) => {
  const type = drawerCaller?.name ?? "Add";
  const filledInfo = drawerCaller?.data ?? {};
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("xs"));
  const isSm = useMediaQuery(theme.breakpoints.between("sm", "xs"));
  const isMd = useMediaQuery(theme.breakpoints.between("md", "sm"));
  const isLg = useMediaQuery(theme.breakpoints.between("lg", "md"));
  const isXl = useMediaQuery(theme.breakpoints.up("xl"));
  let drawerWidth = "600px";
  if (isXs || window.innerWidth < 1000) {
    drawerWidth = "250px"; 
  } else if (isSm) {
    drawerWidth = "300px"; 
  } else if (isMd) {
    drawerWidth = "400px"; 
  } else if (isLg) {
    drawerWidth = "600px"; 
  } else if (isXl) {
    drawerWidth = "600px"; 
  }
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [loader, setLoader] = useState(true);
  const [showmoreLoader, setShowmoreLoader] = useState(false);
  const [information, setInformation] = useState({});
  const [latency, setLatency] = useState([]);
  // const [mappingstream, setMappingStream] = useState([]);
  // const [dropdownvisble, setDropdownvisble] = useState("");
  const [alerttypes, setAlertTypes] = useState([]);
  const handleDrawerClose = (event) => {
    // if (event.target.id === "back-button") {
      setIsDrawerOpen(false);
    // }
  };
  const getLatencyType = () => {
    const body = {
      id: "",
      searchtext: "",
    };
    instance
      .post("api/v1/Master/LatencyType/Get", body)
      .then((res) => {
        if (res?.data?.Success) {
          setLatency((prevData) => [...prevData, ...res?.data?.Value]);
          }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoader(false);
        setShowmoreLoader(false);
      });
  };
  // const getMappingStream = () => {
  //   const body = {
  //     id: "",
  //     searchtext: dropdownvisble,
    
  //   };
  //   instance
  //     .post("api/v1/Master/MappingStream/Get", body)
  //     .then((res) => {
  //       if (res?.data?.Success) {
  //         setMappingStream((prev) => {
  //             return [...prev, ...(res?.data?.Value ?? {})];
  //       })
  //     } 
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     })
  //     .finally(() => {
  //       setLoader(false);
  //       setShowmoreLoader(false);
  //     });
  // };
  const getAlterTypes = () => {
    const body = {
      id: "",
      searchtext: "",
    };
    instance
      .post("api/v1/Master/AlertType/Get",body)
      .then((res) => {
      
        if (res?.data?.Success) {
          // Filter the alert types based on the show_for_message_type value
          const filteredAlertTypes = res.data.Value.filter(
            (alertType) => alertType.show_for_message_type === 1
          );
          setAlertTypes(filteredAlertTypes);
          console.log("rest",filteredAlertTypes);
        }
      })
      //   if (res?.data?.Success) {
         
      //     setAlertTypes((prev) => {
      //         return [...prev, ...(res?.data?.Value ?? {})];
      //   })
      // } 
      // })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoader(false);
        setShowmoreLoader(false);
      });
  };
  const createNewMessageType = () => {
    const message_type_name = information?.message_type_name;
    const mapping_stream_id = information?.mapping_stream_id;
    const filename_pattern_01 = information?.filename_pattern_01;
    const success_alert_type_id = information?.success_alert_type_id;
    const failure_alert_type_id = information?.failure_alert_type_id;
    const latency_type_id = information?.latency_type_id;
    if (
      message_type_name?.length == 0 ||
      filename_pattern_01?.length == 0 ||
      mapping_stream_id?.length === 0 || success_alert_type_id?.length === 0 ||
      failure_alert_type_id?.length === 0 || latency_type_id?.length === 0
    ) {
      setError("Please fill all the mandatory fields");
      return;
    }
    setBackDrop(true);
    const body = {
      message_type_id: information?.message_type_id??"",
      message_type_name: information?.message_type_name??"",
      message_type_is_edifact_inbound:
        information?.message_type_is_edifact_inbound??"",
      success_alert_type_id: information?.success_alert_type_id??"",
      failure_alert_type_id: information?.failure_alert_type_id??"",
      filename_pattern_01: information?.filename_pattern_01??"",
      contents_pattern_01: information?.contents_pattern_01??"",
      contents_pattern_02: information?.contents_pattern_02??"",
      latency_type_id: information?.latency_type_id??"",
      mapping_stream_id: information?.mapping_stream_id??"",
    };
    console.log("body",body);
    instance
      .post("api/v1/Master/MessageType/Post", body)
      .then((res) => {
        if (res?.data?.Success) {
          setError(null);
          setSuccess(res?.data?.ResultMessage);
          getMessageType();
          setTimeout(() => {
            setSuccess(null);
          }, 5000);
        } else {
          setError(res?.data?.ResultMessage);
          setTimeout(() => {
            setError(null);
          }, 5000);
        }
        if(type === "Add")
        {
        setMappingStream([])
        setInformation({
          message_type_name:"",
          mapping_stream_id : "",
          filename_pattern_01 : "",
          success_alert_type_id : "",
          failure_alert_type_id : "",
          latency_type_id : "",
        })}
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setBackDrop(false);
      });
  };
  const onChanageHandler = (event) => {
    const { id, value, type } = event?.target;
    if (type == "checkbox") {
      setInformation((prev) => {
        return {
          ...prev,
          [id]: event?.target?.checked == true ? 1 : 0,
        };
      });
    } else {
      setInformation((prev) => {
        return {
          ...prev,
          [id]: value,
        };
      });
    }
  };
  const handleClick = () => {
    if (dropdownvisble.length >= 3) {
      getMappingStream();
    }
  };
  useEffect(() => {
    setInformation({
      message_type_id: filledInfo?.message_type_id ?? "",
      message_type_name: filledInfo?.message_type_name ?? "",
      message_type_is_edifact_inbound:
      filledInfo?.message_type_is_edifact_inbound ?? "",
      success_alert_type_id: filledInfo?.success_alert_type_id ?? "",
      success_alert_type_name: filledInfo?.success_alert_type_id ?? "",
      failure_alert_type_id: filledInfo?.failure_alert_type_id ?? "",
      failure_alert_type_name: filledInfo?.success_alert_type_id ?? "",
      filename_pattern_01: filledInfo?.filename_pattern_01 ?? "",
      contents_pattern_01: filledInfo?.contents_pattern_01 ?? "",
      contents_pattern_02: filledInfo?.contents_pattern_02 ?? "",
      latency_type_id: filledInfo?.latency_type_id ?? "",
      latency_type_name: filledInfo?.latency_type_name ?? "",
      mapping_stream_id: filledInfo?.mapping_stream_id ?? "",
      mapping_stream_name:filledInfo?.mapping_stream_name ?? "",
    });
  }, [drawerCaller]);
  
  useEffect(() => {
  getLatencyType();
  // getMappingStream();
  getAlterTypes();
}, []);

mappingstream.find(
  (option) =>{
    console.log("option",drawerCaller?.data?.mapping_stream_id,mappingstream,option);
    return option?.mapping_stream_id === information?.mapping_stream_id
   }
) 
  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      PaperProps={{
        sx: {width: drawerWidth}}}>
      <div
        style={{ padding: "20px" }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Button
              id="back-button"
              variant="contained"
              color="transparent"
              className="button_backmsg"
              onClick={handleDrawerClose}
              startIcon={<ArrowBackIcon  onClick={handleDrawerClose}/>}
            >
              Back
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="h5"
              className="font-colormsg mb-0"
              style={{ fontWeight: "600" }}
            >
              {type == "Add" ? "Add" : "Edit"} Message Type{" "}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="h7"
              className="font-colormsg mb-1"
              style={{ fontWeight: "600" }}
            >
              Message Type Information{" "}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            {error && (
              <Alert
                variant="outlined"
                severity="error"
                icon={
                  <CancelIcon
                    onClick={() => setError(null)}
                    style={{ cursor: "pointer" }}
                  />
                }
                className="errorAlertMaintain mt-4"
              >
                {error}
              </Alert>
            )}
            {success && (
              <Alert
                variant="outlined"
                severity="success"
                className="sucessAlertMaintain mt-4"
              >
                {success}
              </Alert>
            )}
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="message_type_name">Type Name<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              id="message_type_name"
              size="small"
              value={information?.message_type_name}
              onChange={onChanageHandler}
              // placeholder="Enter name"
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="success_alert_type_id">
              Success Alert Type<span style={{ color: "red" }}>*</span>
            </InputLabel>
            <Autocomplete
              size="small"
              id={"success_alert_type_id"}
              options={alerttypes}
              getOptionLabel={(option) => option.alert_type_name}
              value={
                alerttypes.find(
                  (option) => option.alert_type_id === information.success_alert_type_id
                ) || null
              }
              onChange={(event, newValue) => {
                setInformation((prev) => {
                  console.log("newValue",newValue);
                  return {
                    ...prev,
                    success_alert_type_id: newValue?.alert_type_id || 0,
                    success_alert_type_name: newValue?.alert_type_name || null
                  };
                });
              }}
              disableClearable
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  variant="outlined"
                  // InputProps={{
                  //   ...params.InputProps,
                  //   endAdornment: (
                  //     <InputAdornment
                  //         position="end"
                  //         style={{ position: "absolute", right: 20 }}
                  //       >
                  //       <img
                  //         src="assets/Images/searchicon.svg"
                  //         alt="Search Icon"
                  //       />
                  //     </InputAdornment>
                  //   ),
                  // }}
                />
              )} />
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="failure_alert_type_id">
              Failure Alert Type<span style={{ color: "red" }}>*</span>
            </InputLabel>
            <Autocomplete
              size="small"
              id={"failure_alert_type_id"}
              options={alerttypes}
              getOptionLabel={(option) => option.alert_type_name}
              value={
                alerttypes.find(
                  (option) => option.alert_type_id === information.failure_alert_type_id
                ) || null
              }
              onChange={(event, newValue) => {
                setInformation((prev) => {
                  console.log("newValue",newValue);
                  return {
                    ...prev,
                    failure_alert_type_id: newValue?.alert_type_id || 0,
                    failure_alert_type_name: newValue?.alert_type_name || null
                  };
                });
              }}
              disableClearable
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  variant="outlined"
                  // InputProps={{
                  //   ...params.InputProps,
                  //   endAdornment: (
                  //     <InputAdornment
                  //         position="end"
                  //         style={{ position: "absolute", right: 20 }}
                  //       >
                  //       <img
                  //         src="assets/Images/searchicon.svg"
                  //         alt="Search Icon"
                  //       />
                  //     </InputAdornment>
                  //   ),
                  // }}
                />
              )} />
          </Grid>
          <Grid item xs={12}>
            <Checkbox
              color="secondary"
              id="message_type_is_edifact_inbound"
              checked={
                information?.message_type_is_edifact_inbound == 1 ? true : false
              }
              onChange={onChanageHandler}
            />
            <Typography variant="h7" className="font-colormsg mb-1">
             Is EDIFact Inbound?
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="filename_pattern_01">
              {" "}
              Filename pattern 01<span style={{ color: "red" }}>*</span>
            </InputLabel>
            <TextField
              id="filename_pattern_01"
              size="small"
              value={information?.filename_pattern_01}
              onChange={onChanageHandler}
              //  placeholder="Enter name"
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <InputLabel htmlFor="contents_pattern_01">
              Contents pattern 01
            </InputLabel>
            <TextField
              id="contents_pattern_01"
              size="small"
              value={information?.contents_pattern_01}
              onChange={onChanageHandler}
              //  placeholder="Enter name"
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <InputLabel htmlFor="contents_pattern_02">
              Contents pattern 02
            </InputLabel>
            <TextField
              id="contents_pattern_02"
              size="small"
              value={information?.contents_pattern_02}
              onChange={onChanageHandler}
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="alert_type_id">Latency Type<span style={{ color: "red" }}>*</span></InputLabel>
            <Autocomplete
              size="small"
              id={"alert_type_id"}
              options={latency}
              getOptionLabel={(option) => option.latency_type_name}
              value={
                latency.find(
                  (option) => option.latency_type_id === information.latency_type_id
                ) || null
              }
              onChange={(event, newValue) => {
                setInformation((prev) => {
                  console.log("newValue",newValue);
                  return {
                    ...prev,
                    latency_type_id: newValue?.latency_type_id || 0,
                    latency_type_name:newValue?.latency_type_name || null
                  };
                });
              }}
              disableClearable
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  variant="outlined"
                  // InputProps={{
                  //   ...params.InputProps,
                  //   endAdornment: (
                  //     <InputAdornment
                  //         position="end"
                  //         style={{ position: "absolute", right: 20 }}
                  //       >
                  //       <img
                  //         src="assets/Images/searchicon.svg"
                  //         alt="Search Icon"
                  //       />
                  //     </InputAdornment>
                  //   ),
                  // }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="mapping_stream_id">Mapping Stream<span style={{ color: "red" }}>*</span></InputLabel>
            <Autocomplete
              size="small"
              id="mapping_stream_id"
              options={mappingstream}
              getOptionLabel={(option) => option.mapping_stream_name}
              value={
                mappingstream.length ?
                 mappingstream.find(
                  (option) =>{
                    return option?.mapping_stream_id ===drawerCaller?.data?.mapping_stream_id
                   }
                ) 
                : null
              }
              onChange={(event, newValue) => {
                setInformation((prev) => {
                  console.log("newValue",newValue);
                  return {
                    ...prev,
                    mapping_stream_id: newValue?.mapping_stream_id || 0,
                    mapping_stream_name:newValue?.mapping_stream_name || null
                  };
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  variant="outlined"
                  onChange={(event) => {
                    setDropdownvisble(event.target.value);
                    if(event.target.value.length < 3){
                      console.log("hey",event.target.value,mappingstream);
                      setMappingStream([]);
                    }
                   
                  }}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <InputAdornment
                          position="end"
                          style={{ position: "absolute", right: 20 ,cursor:"pointer"}}
                          onClick={handleClick}
                        >
                        <img
                          src="assets/Images/searchicon.svg"
                          alt="Search Icon"
                        />
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sx={{ textAlign: "right" }}>
            <Button
              id="back-button"
              variant="contained"
              color="secondary"
              onClick={createNewMessageType}
            >
              {type == "Add" ? "Create" : "Save Changes"}
            </Button>
          </Grid>
        </Grid>
      </div>
    </Drawer>
  );
};

export default MessageTypesDrawer;
